import React, { Fragment, ReactNode } from "react";
import { Typography } from "@mui/material";

import "./style.scss";

interface ISearchListHeaderLabelProps {
    propertyKey?: string;
    label: string;
    value: string;
    chip?: ReactNode;
    whenNotEmpty?: boolean;
    valueClassName?: string;
}

export const SearchListHeaderLabel = (props: ISearchListHeaderLabelProps) => {
    if (props.whenNotEmpty && (props.value ?? "") === "") {
        return <></>;
    }

    return <Fragment>
        <Typography variant={"h4"} className={"list-detail__item"}>
        {props.label}
        <div className={"list-detail__value"}>
            <span data-testid={props.propertyKey} className={props.valueClassName}>{props.value}</span>
            {props.chip}
        </div>
    </Typography>
    </Fragment>;
};
